module.exports = __webpack_public_path__ + "img/pic_feed_vip2.69937316.png";